const myNews = () => import('@/pages/myNews/myNews.vue');

export default [{
  path: '/myNews',
  name: 'myNews',
  meta: {
    isLogin: true
  },
  component: myNews
}, ]